import { CheckCircle2 } from "lucide-react";

export const SuccessMessage = ({ onReset }) => (
  <div
    id="kontaktformular"
    role="status"
    aria-live="polite"
    className="rounded-3xl border-2 border-[var(--ink)] bg-[var(--paper)] p-6 outline-none sm:p-10"
  >
    <CheckCircle2 size={40} className="text-[#2f7a46]" aria-hidden />
    <h3 className="font-display mt-4 text-2xl font-bold sm:text-3xl">
      Tack! Din förfrågan är skickad.
    </h3>
    <p className="mt-3 text-[var(--ink-soft)]">Mats återkommer så snart som möjligt.</p>
    <button type="button" onClick={onReset} className="btn btn-outline mt-6">
      Skicka en ny förfrågan
    </button>
  </div>
);
